import { http } from '@pendo/http';

export function createRule (rule) {
    return http
        .post('/api/s/_SID_/automationrule', rule)
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function updateRule (rule) {
    return http
        .patch(`/api/s/_SID_/automationrule/${rule.id}`, rule)
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function fetchAutomationRules () {
    return http
        .get('/api/s/_SID_/automationrule')
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function runRule (ruleId) {
    return http
        .post(`api/s/_SID_/automationrule/run/${ruleId}`)
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function fetchAgg ({ conditionConfig, actionConfig }) {
    return http
        .post('/api/s/_SID_/automationrule/agg', {
            conditionConfig,
            actionConfig,
        })
        .then((res) => {
            try {
                return JSON.parse(res.data.agg);
            } catch (err) {
                throw err;
            }
        })
        .catch((err) => {
            throw err;
        });
}

export function deleteRule (ruleId) {
    return http.delete(`/api/s/_SID_/automationrule/${ruleId}`).catch((err) => {
        throw err;
    });
}

export function reorderRules ({ automationRuleIds, orderedGroupId }) {
    return http.post(`/api/s/_SID_/automationrule/reorder/${orderedGroupId}`, { automationRuleIds }).catch((err) => {
        throw err;
    });
}
